import { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import SearchBoxWithCustomQuery from "../../common/SearchBoxWithCustomQuery";
import Table from "../../common/Table/Table";
import auctionService from "../../services/auction/auction.service";
import MetaportalModal from "./metaportalModel";
import { errorToast, successToast } from "../../react-toastfiy/toast";
import { set } from "lodash";

const MetaportalKeys = () => {
    const source = axios.CancelToken.source();
    const [showModal, setShowModal] = useState(false);
    const [selectedId, setSelectedId] = useState(false);
    const [loading, setLoading] = useState(false);
    const [allApiKeyList, setAllApiKeyList] = useState([]);
    const [filteredApiKeyList, setFilteredApiKeyList] = useState([]);

    const columns = [
        {
            title: "#",
            data_key: "",
            th_text_position: "center",
            td_text_position: "center",
            render: (row, index) => {
                return <>{index + 1}</>;
            },
        },
        {
            title: "Financier Name",
            data_key: "brand_name",
            th_text_position: "center",
            td_text_position: "center",
            sortable: false,
            render: (row) => {
                return (
                    <>
                        <span className=" text-nowrap">{row?.brand_name}</span>{" "}

                    </>
                );
            },
        },
        {
            title: "Production Key",
            data_key: "prod_key",
            th_text_position: "center",
            td_text_position: "center",
            sortable: false,
            render: (row) => {
                return (
                    <>
                        <span className=" text-nowrap">{row?.prod_key}</span>{" "}

                    </>
                );
            },
        },
        {
            title: "UAT Key",
            data_key: "uat_key",
            th_text_position: "center",
            td_text_position: "center",
            sortable: false,
            render: (row) => {
                return (
                    <>
                        <span className=" text-nowrap">{row?.uat_key}</span>{" "}

                    </>
                );
            },
        },
        {
            title: "Actions",
            data_key: "actions",
            render: (value) => {
                return (
                    <div className="btn-group btn-group-sm" role="group">
                        <button
                            type="button"
                            className="btn btn-outline-primary"
                            onClick={() => {
                                setSelectedId(value?.id);
                                setShowModal(true);
                            }}
                            title="Edit Key"
                        >
                            <i className="bi bi-pencil"></i>
                        </button>
                        <button
                            type="button"
                            className="btn btn-outline-danger"
                            onClick={() => handleDeleteKey(value)}
                            title="Delete Key"
                        >
                            <i className="bi bi-trash"></i>
                        </button>
                    </div>
                );
            },
            th_text_position: "center",
            td_text_position: "center",
        },
    ];

    const handleDeleteKey = async (value) => {
        Swal.fire({
            title: "Are you sure?",
            html: `<p>You want to delete ${value?.brand_name}'s key!</p>`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: `Yes, Delete it!`,
            showLoaderOnConfirm: true,
            preConfirm: async () => {
                try {
                    setLoading(true);
                    const formdata = new FormData();
                    formdata.append("id", value?.id);
                    auctionService.DeleteAPIKey(formdata)
                        .then((res) => {
                            setLoading(false);
                            if (res?.status === 200) {
                                successToast("API Key Deleted Successfully");
                                setFilteredApiKeyList((prev) =>
                                    prev.filter((item) => item.id !== value?.id)
                                );
                                setAllApiKeyList((prev) =>
                                    prev.filter((item) => item.id !== value?.id)
                                );
                            } else {
                                errorToast(res?.msg);
                            }
                        });
                } catch (error) {

                }
            },
        });
    }

    useEffect(() => {
        try {
            setLoading(true);
            auctionService.GetAllAPIKeys(source)
                .then((res) => {
                    setLoading(false);
                    if (res?.status === 200) {
                        setFilteredApiKeyList(res?.data || []);
                        setAllApiKeyList(res?.data || []);
                    } else {
                        setAllApiKeyList([]);
                        setFilteredApiKeyList([]);
                        setLoading(false);
                    }
                });
        } catch (error) {
            setLoading(false);
        }
    }, []);

    return (
        <>
            {showModal && (
                <MetaportalModal
                    show={showModal}
                    id={selectedId}
                    removeFinancierIdList={selectedId ? [] : allApiKeyList.map((item) => item.brand_id)}
                    onHide={() => {
                        setShowModal(false);
                    }}
                />
            )}
            <div className="container">
                <h3 className="mb-3">MetaPortal Keys</h3>
                <div className="d-flex flex-wrap justify-content-between align-items-center mb-3 gap-2">
                    <div className="flex-grow-1 me-sm-2 me-0" style={{ minWidth: "250px" }}>
                        <SearchBoxWithCustomQuery
                            placeholder="Search by Financier Name"
                            allData={allApiKeyList}
                            setFilteredData={setFilteredApiKeyList}
                            return_array={true}
                            keysToSearchOn={["brand_name"]}
                        />
                    </div>
                    <button
                        type="button"
                        className="btn btn-primary d-flex align-items-center justify-content-center col-12 col-sm-4 col-md-3 col-lg-2"
                        style={{ fontSize: "14px" }}
                        onClick={() => {
                            setSelectedId(null);
                            setShowModal(true);
                        }}
                    >
                        <i className="bi bi-plus-circle me-1" style={{ fontSize: "16px" }}></i>
                        Add New Key
                    </button>
                </div>
                <Table
                    columns={columns}
                    data={filteredApiKeyList}
                    loading={loading}
                    no_data_msg="No data"
                    // td_text_position="left"
                    td_class="text-capitalize"
                    td_style={{ fontSize: "0.9rem" }}
                    th_text_position="start"
                    td_text_position="start"
                    loading_cols={columns.length}
                    loading_rows={5}
                />
            </div>
        </>
    )
};


export default MetaportalKeys;
